import { InputTextarea } from "primereact/inputtextarea";

const TextAreaWithCounter = ({
    value,
    onChange,
    maxLength = 750,
    placeholder = "",
    style = {},
    textareaProps = {}
}) => {
    const safeValue = value ?? "";

    const handleChange = (e) => {
        onChange?.(e);
    };

    return (
        <div style={{ width: "100%" }}>
            <InputTextarea
                value={safeValue}
                onChange={handleChange}
                maxLength={maxLength}
                autoResize
                style={{
                    borderRadius: "10px",
                    width: "100%",
                    ...style
                }}
                placeholder={placeholder}
                {...textareaProps}
            />

            <div
                style={{
                    textAlign: "right",
                    fontSize: "12px",
                    marginTop: "4px",
                    color:
                        safeValue.length >= maxLength
                            ? "#d32f2f"
                            : "#6c757d"
                }}
            >
                {safeValue.length} / {maxLength}
            </div>
        </div>
    );
};

export default TextAreaWithCounter;